export default function RefundPolicyPage() {
  return (
    <div data-testid="page-refunds" className="bg-[#F9F8F6]">
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#8E6A2B] mb-6">— Refunds</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[#0F292F] font-light tracking-tight leading-[1.05]">
          Refund & Cancellation Policy
        </h1>
        <p className="mt-6 text-sm text-[#52525B]">Effective: December 2025</p>

        <div className="mt-12 space-y-10 text-[#1A1A1A] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">1. Introductory Consultations</h2>
            <p>
              The 30-minute introductory consultation offered through our booking page is
              <strong> complimentary</strong>. No payment is charged, and therefore no refund
              is applicable. You may cancel or reschedule at any time by replying to your
              confirmation email or writing to helliotassociates@gmail.com.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">2. Booking Deposits (if applicable)</h2>
            <p>
              If a deposit is required to secure a paid appointment, the following applies:
            </p>
            <ul className="mt-4 space-y-2 list-disc pl-6">
              <li><strong>Cancellation 48 hours or more before the appointment:</strong> 100% refund of the deposit.</li>
              <li><strong>Cancellation less than 48 hours before:</strong> 50% refund; the remaining 50% is retained as a booking fee.</li>
              <li><strong>No-show or cancellation less than 2 hours before:</strong> Non-refundable; the deposit is forfeited.</li>
            </ul>
            <p className="mt-3">
              Rescheduling (as opposed to cancelling) is always free provided at least 24 hours'
              notice is given. Deposits credit toward the engagement fee if you retain the firm.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">3. Engagement Retainers</h2>
            <p>
              Paid engagements typically require a retainer described in the engagement letter.
              Retainers are refundable only to the extent that fees for work actually performed
              — billed at the rates in the engagement letter — are less than the retainer paid.
              Any unused portion will be returned within 14 business days of engagement
              termination via ACH, check, or the original payment method.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">4. Completed Tax Returns & Deliverables</h2>
            <p>
              Once a tax return has been filed with a taxing authority, or a written deliverable
              (e.g., retirement-planning memo, IRS-response letter) has been transmitted to you
              or to a third party on your behalf, <strong>the related fee is non-refundable</strong>.
              Filed returns and transmitted documents represent completed work product.
            </p>
            <p className="mt-3">
              If we believe an error was made by the firm, we will correct the error at no
              additional charge. If the issue cannot be resolved to your satisfaction, please
              see Section 7 below.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">5. IRS Representation Engagements</h2>
            <p>
              IRS representation engagements (audits, appeals, collections) are billed against a
              retainer or on a flat-fee basis per the engagement letter. Fees for representation
              hours already worked are non-refundable. Unused retainer balances are returned as
              described in Section 3.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">6. Subscriptions (if applicable)</h2>
            <p>
              If you enroll in a recurring (monthly or annual) planning package, you may cancel
              at any time with written notice. Cancellation stops future billing; the current
              billing period is not pro-rated or refunded. Your access to services rendered
              during the paid period continues until the end of that period.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">7. Disputes, Chargebacks & Good-Faith Resolution</h2>
            <p>
              If you are dissatisfied with any service, please contact the firm at
              helliotassociates@gmail.com or (571) 598-5790 <strong>before</strong> initiating a
              credit-card chargeback. The firm will respond within two business days and
              attempt in good faith to resolve the matter — which may include a refund, credit,
              or revision of the work.
            </p>
            <p className="mt-3">
              Chargebacks filed without first contacting the firm may be contested with the
              relevant card network, as the firm keeps detailed records of engagement letters,
              delivered work, and communications.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">8. How Refunds Are Issued</h2>
            <p>
              Approved refunds are issued to the original method of payment within 5–10 business
              days of approval. Stripe and your issuing bank may require an additional 3–5
              business days to post the credit to your statement.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">9. Contact for Refund Requests</h2>
            <p>
              To request a refund or discuss a billing concern, email helliotassociates@gmail.com
              with your name, the invoice or engagement reference, and a brief description of
              the issue. Written requests help ensure a complete record and a timely response.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">10. Changes to This Policy</h2>
            <p>
              This policy may be updated from time to time. The version in effect on the date
              your engagement letter is signed governs that engagement; subsequent changes
              apply only to new engagements.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
